<template>
  <div>
    <div v-if="loading" class="text-center">
      <small class="text-muted">Cargando...</small><br />
      <div class="lds-circle"><div></div></div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div>
          <div>
            <div>
              <h4>Tus favoritos</h4>
              <span v-if="aliados.length != 0"
                >{{ aliados.length }}
                <span v-if="aliados.length > 1"> aliados</span
                ><span v-else> aliado</span>
                <span v-if="aliados.length > 1"> agregados</span
                ><span v-else> agregado</span></span
              >
              <span v-else>Aún no has agregado favoritos.</span>
            </div>
          </div>
          <div class="list item-list recent-jobs-list">
            <ul>
              <li
                v-for="(aliado, index_aliado) in aliados"
                v-bind:key="index_aliado"
              >
                <router-link v-bind:to="'/aliado/' + aliado.id_aliado">
                  <div class="item-content">
                    <div class="item-media item-aliado">
                      <img
                        v-if="aliado.logo_app == null"
                        src="https://arboledadev.com/reddy/api/assets/images/logo_aliado.png"
                        alt="logo"
                        style="max-width: 90px"
                      />
                      <img
                        v-else
                        v-bind:src="aliado.logo_app"
                        v-bind:alt="aliado.nombre_aliado"
                        style="max-width: 90px"
                      />
                    </div>
                    <div class="item-inner">
                      <div class="item-title-row mb-0">
                        <h6 class="item-title">
                          <router-link
                            v-bind:to="'/aliado/' + aliado.id_aliado"
                            class="text-primary text-uppercase"
                            >{{ aliado.nombre_aliado }}</router-link
                          >
                        </h6>
                      </div>
                       <div class="d-flex align-items-center text-muted mb-0">
                          <div v-if="aliado.sucursal!=null" class="text-capitalize">
                            <i class="fas fa-map-marker-alt me-1"></i>   {{aliado.sucursal.sucursal}}
                          </div>
                        </div>
                      <div class="d-flex align-items-center text-muted mb-0">
                       Zona
                        <span v-if="aliado.zona == 1" class="ms-1"> Norte</span>
                        <span v-if="aliado.zona == 2" class="ms-1"> Sur</span>
                        <span v-if="aliado.zona == 3" class="ms-1"> Este</span>
                        <span v-if="aliado.zona == 4" class="ms-1"> Oeste</span>
                        <span v-if="aliado.zona == 5" class="ms-1">
                          Centro</span
                        >
                      </div>
                      <div class="d-flex align-items-center mb-2">
                        <svg
                          class="text-primary"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M8.5 23C9.70017 23.0072 10.8898 22.7761 12 22.32C13.109 22.7799 14.2995 23.0112 15.5 23C19.145 23 22 21.055 22 18.571V14.429C22 11.945 19.145 10 15.5 10C15.331 10 15.165 10.008 15 10.017V5.333C15 2.9 12.145 1 8.5 1C4.855 1 2 2.9 2 5.333V18.667C2 21.1 4.855 23 8.5 23ZM20 18.571C20 19.72 18.152 21 15.5 21C12.848 21 11 19.72 11 18.571V17.646C12.3542 18.4696 13.9153 18.8898 15.5 18.857C17.0847 18.8898 18.6458 18.4696 20 17.646V18.571ZM15.5 12C18.152 12 20 13.28 20 14.429C20 15.578 18.152 16.857 15.5 16.857C12.848 16.857 11 15.577 11 14.429C11 13.281 12.848 12 15.5 12ZM8.5 3C11.152 3 13 4.23 13 5.333C13 6.43601 11.152 7.66701 8.5 7.66701C5.848 7.66701 4 6.43701 4 5.333C4 4.229 5.848 3 8.5 3ZM4 8.48201C5.35986 9.28959 6.91876 9.7001 8.5 9.66701C10.0812 9.7001 11.6401 9.28959 13 8.48201V10.33C11.9102 10.6047 10.9107 11.1586 10.1 11.937C9.57422 12.0508 9.03795 12.1091 8.5 12.111C5.848 12.111 4 10.881 4 9.77801V8.48201ZM4 12.927C5.36015 13.7338 6.91891 14.1439 8.5 14.111C8.678 14.111 8.85 14.089 9.025 14.08C9.0101 14.1958 9.00176 14.3123 9 14.429V16.514C8.832 16.524 8.67 16.556 8.5 16.556C5.848 16.556 4 15.326 4 14.222V12.927ZM4 17.371C5.35986 18.1786 6.91876 18.5891 8.5 18.556C8.668 18.556 8.833 18.543 9 18.535V18.571C9.01431 19.4223 9.34144 20.2385 9.919 20.864C9.45111 20.9524 8.97615 20.9979 8.5 21C5.848 21 4 19.77 4 18.667V17.371Z"
                            fill="#40189D"
                          />
                        </svg>
                        <div
                          v-if="aliado.alianza != null"
                          class="item-price text-grey"
                        >
                          {{ aliado.alianza.tipo_descuento }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="sortable-handler"></div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Favoritos",
  metaInfo: {
    title: "Favoritos - Reddy App",
  },
  data() {
    return {
      loading: true,
      aliados: [],
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.get_favoritos();
  },
  methods: {
    get_favoritos: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {},
      };
      const vm = this;
      axios
        .get(this.$base_url + "membresias/favoritos", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
          } else {
            this.aliados = response.data.data.aliados;
            this.loading = false;
          }
        })
        .catch((error) =>
          vm.$notify({
            type: "error",
            group: "foo",
            title: "<i class='fa fa-exclamation-circle'></i> Ups!",
            text: error,
          })
        )
        .finally();
    },
  },
};
</script>
